import { Grid, FormControl, withStyles } from '@material-ui/core'
import { Checkbox, FormControlLabel } from '@mui/material';
import RegularButton from 'components/CustomButtons/Button'
import React, { memo, useState, } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeStationConfigurations } from 'redux/actions/companies/companiesAction_V2'

const CustomFormControlLabel = withStyles({
    root: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    label: {
        margin: 0,
        color: "grey"
    }
})(FormControlLabel);

export const FormStationConfigurationsEdit = memo((props) => {
    const { handleClose, data } = props
    const { isLoadingComp } = useSelector(({ search }) => search);
    const [showDigitalTanks, setDigitalTanks] = useState(data?.show_digital_tanks);
    const [showDigitalAutotanks, setDigitalAutotanks] = useState(data?.show_digital_autotanks);
    const [showDigitalStations, setDigitalStations] = useState(data?.show_digital_stations);
    const dispatch = useDispatch()

    const handleSubmit = () => {
        const newValues = {
            id_company: data.id_company,
            id: data.id,
            showDigitalTanks,
            showDigitalAutotanks,
            showDigitalStations
        }
        dispatch(changeStationConfigurations(newValues, handleClose))
    }

    return (
        <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20 }} onSubmit={handleSubmit}>
            <CustomFormControlLabel control={<Checkbox
                name="showDigitalTanks"
                onChange={() => setDigitalTanks(!showDigitalTanks)}
                checked={showDigitalTanks}
                color='success'
                sx={{
                    color: 'rgb(246,110,94)',
                    '&.Mui-checked': {
                        color: 'rgb(98, 212, 102)',
                    },
                }}
            />}
                labelPlacement="start"
                label="Inventario de Tanques"
            />
            <CustomFormControlLabel control={<Checkbox
                name="showDigitalAutotanks"
                onChange={() => setDigitalAutotanks(!showDigitalAutotanks)}
                checked={showDigitalAutotanks}
                color='success'
                sx={{
                    color: 'rgb(246,110,94)',
                    '&.Mui-checked': {
                        color: 'rgb(98, 212, 102)',
                    },
                }}
            />}
                labelPlacement="start"
                label="Inventario de AutoTanques"
            />
            <CustomFormControlLabel control={<Checkbox
                name="showDigitalStations"
                onChange={() => setDigitalStations(!showDigitalStations)}
                checked={showDigitalStations}
                color='success'
                sx={{
                    color: 'rgb(246,110,94)',
                    '&.Mui-checked': {
                        color: 'rgb(98, 212, 102)',
                    },
                }}
            />}
                labelPlacement="start"
                label="Inventario de Estaciones"
            />
            <Grid
                item
                xs={12}
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 8,
                }}
            >
                <RegularButton
                    color="danger"
                    onClick={handleClose}
                    loading={isLoadingComp?.loadingStationsActions}
                >
                    Cancelar
                </RegularButton>
                <RegularButton
                    color="info"
                    onClick={handleSubmit}
                    loading={isLoadingComp?.loadingStationsActions}
                >  Actualizar </RegularButton>
            </Grid>
        </FormControl>
    )
})